import SvgColor from 'src/components/svg-color';

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{width: 1, height: 1}} />
);

const navConfig = [
  {
    title: 'Home',
    path: '/',
    icon: icon('ic_home'),
  },
  {
    title: 'Clicker config',
    path: '/cfg-config',
    icon: icon('ic_cfg_config'),
  },
  {
    title: 'Statistics',
    path: '/statistics',
    icon: icon('ic_cfg_config'),
  },
  {
    title: 'Global runtime',
    path: '/system-config',
    icon: icon('ic_cfg_config'),
    adminOnly: true,
  },
  {
    title: 'Navigation config',
    path: '/navigation-config',
    icon: icon('ic_cfg_config'),
    adminOnly: true,
  },
  {
    title: 'Scroller config',
    path: '/scroller-config',
    icon: icon('ic_cfg_config'),
    adminOnly: true,
  },
  {
    title: 'Rules config',
    path: '/rules-config',
    icon: icon('ic_cfg_config'),
    adminOnly: true,
  },
  {
    title: 'Name config',
    path: '/name-config',
    icon: icon('ic_cfg_config'),
    adminOnly: true,
  },
  {
    title: 'Wit audit',
    path: '/wit-audit',
    icon: icon('ic_cfg_config'),
    adminOnly: true,
  },
  {
    title: 'Wit thresholds',
    path: '/wit-thresholds',
    icon: icon('ic_cfg_config'),
    adminOnly: true,
  },
  {
    title: 'Wit training queue',
    path: '/wit-training-queue',
    icon: icon('ic_cfg_config'),
    adminOnly: true,
  },
  {
    title: 'Profile',
    path: '/profile',
    icon: icon('ic_profile'),
  },
  {
    title: 'About',
    path: '/about',
    icon: icon('ic_about'),
  },
  {
    title: 'Private policy',
    path: '/private-policy',
    icon: icon('ic_private'),
  },
];

export default navConfig;
